import { Injectable } from '@angular/core';
import { Cxcenccobmulti } from "../cxcinterfaces/cxcencobmulti";
import { Cxcdetcobmulti } from "../cxcinterfaces/cxcdetcobmulti";
import { Cxctrnformapago } from '../cxcinterfaces/cxctrnformapago';
import { Cxctrnvarios } from '../cxcinterfaces/cxctrnvarios';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfInicialesService } from '../../servicios/conf-iniciales.service';
import { Observable, of } from 'rxjs';
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { UsuarioEsquema } from '../../usuarioEsquema';
import { Usuario } from '../../usuario';
import { isNullOrUndefined } from 'util';
import { MessageService } from 'primeng/api';
import { UtilitariosService } from '../../advantage/advantageservices/utilitarios.service';

@Injectable({
  providedIn: 'root'
})
export class CxccobromultipleService {

  public url: string;
  public way: string;

  public cxcenccobmulti: Cxcenccobmulti[] = []
  public cxcdetcobmulti: Cxcdetcobmulti[][] = []

  public cxctrnformapagoarray: Cxctrnformapago[][] = [];
  public cxctrnvariosarray: Cxctrnvarios[][] = [];
  public dblTotalFormaPagoarray: number[] = [];

  public hmpConfiguracion: any[];

  constructor(
    private http: HttpClient,
    private confIniciales: ConfInicialesService,
    private init: NuevoComponentService,
    public usuarioEsquema: UsuarioEsquema,
    public usuario: Usuario,
    private message: MessageService,
    private utilitariosService: UtilitariosService,
  ) {
    this.url = sessionStorage.getItem('url');
    this.way = sessionStorage.getItem('way');
  }
  refrescarURL() {
    if (this.url === null) {
      this.url = sessionStorage.getItem('url');
    }
    if (this.way === null) {
      this.way = sessionStorage.getItem('way');
    }
  }

  erBusquedaVendedor(strCampo, strTabla, strValue, strParam) {

    return this.http.post(this.way + '/ventas/facturas/3rw6uc890a4nleo', {

      elementos: {
        CAMPO: strCampo,
        VALOR: strTabla,
        VALUE: strValue,
        PARAM: strParam
      },

    }, this.confIniciales.httpOptions());

  }
  desplegarDocumentos(desde, hasta): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxccobmulti/662fcf55b867ac000000', {
      elementos: {
        p_opcion: 'CMC',
        p_filtro: 'C.COM_CODIGO=\'01\' ',
        p_condicion: ' to_date(to_char(TRNCOBRO_fechaTrn,\'DD/MM/YYYY\'),\'DD/MM/YYYY\') between to_date(\'' + desde + '\',\'DD/MM/YYYY\') and to_date(\'' + hasta + '\',\'DD/MM/YYYY\')',
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  parseToIntAndScale(n) {
    const s = String(n);
    if (s.indexOf('e') !== -1) {
      return this.parseToIntAndScale(Number(s).toFixed(18).replace(/0+$/, ''));
    }
    const parts = s.split('.');
    const scale = parts[1] ? parts[1].length : 0
    const intVal = Number(parts.join(''));
    return { intVal, scale }
  }
  toScalate(n, decimales) {
    if (isNullOrUndefined(n) || n === '') {
      return 0
    }
    const p = this.parseToIntAndScale(n);
    if (p.scale === decimales) {
      return p.intVal
    }
    if (p.scale < decimales) {
      return p.intVal * Math.pow(10, decimales - p.scale)
    } else {
      const factor = Math.pow(10, p.scale - decimales)
      return Math.round(p.intVal / factor)
    }
  }
  calcularTotalDeuda() {
    let totdeuda = 0
    for (let fila1 = 0; fila1 < this.cxcdetcobmulti[this.init.tabs[this.init.tabindex].indice].length; fila1++) {
      let item: Cxcdetcobmulti = this.cxcdetcobmulti[this.init.tabs[this.init.tabindex].indice][fila1]
      totdeuda = this.utilitariosService.sumar(totdeuda,item.DETCOB_SALDOINI)//this.toScalate(item.DETCOB_SALDOINI, 2)
    }
    //totdeuda = Number(totdeuda / Math.pow(10, 2))
    this.cxcenccobmulti[this.init.tabs[this.init.tabindex].indice].TOTALDEUDA = this.utilitariosService.formatear(totdeuda,2)//Number(totdeuda).toFixed(2)
  }
  calcularImporteTotal() {
    let totdocs = 0

    for (let fila1 = 0; fila1 < this.cxcdetcobmulti[this.init.tabs[this.init.tabindex].indice].length; fila1++) {
      let item: Cxcdetcobmulti = this.cxcdetcobmulti[this.init.tabs[this.init.tabindex].indice][fila1]
      if (item.SELECCIONADO) {
        totdocs += this.toScalate(item.DETCOB_IMPORTE, 2)
      }
    }

    totdocs = Number(totdocs / Math.pow(10, 2))
    this.cxcenccobmulti[this.init.tabs[this.init.tabindex].indice].ENCCOB_IMPORTE = Number(totdocs).toFixed(2)
  }
  calcularTotalFormaPago() {
    this.dblTotalFormaPagoarray[this.init.tabs[this.init.tabindex].indice] = 0;
    this.cxcenccobmulti[this.init.tabs[this.init.tabindex].indice].TOTALVAR = 0;
    let totaldebe = 0
    let totalhaber = 0
    let totalvar = 0
    for (let fila = 1; fila <= this.cxctrnformapagoarray[this.init.tabs[this.init.tabindex].indice].length; fila++) {
      if (this.cxctrnformapagoarray[this.init.tabs[this.init.tabindex].indice][fila - 1].TRNPAGO_TIPO.length > 0) {
        this.dblTotalFormaPagoarray[this.init.tabs[this.init.tabindex].indice] += Number(this.cxctrnformapagoarray[this.init.tabs[this.init.tabindex].indice][fila - 1].TRNPAGO_IMPORTE);
        this.cxctrnformapagoarray[this.init.tabs[this.init.tabindex].indice][fila - 1].TRNPAGO_IMPORTE = Number(this.cxctrnformapagoarray[this.init.tabs[this.init.tabindex].indice][fila - 1].TRNPAGO_IMPORTE).toFixed(2);
      }
    }
    for (let fila1 = 0; fila1 < this.cxctrnvariosarray[this.init.tabs[this.init.tabindex].indice].length; fila1++) {
      let item: Cxctrnvarios = this.cxctrnvariosarray[this.init.tabs[this.init.tabindex].indice][fila1]
      totaldebe += this.toScalate(item.DEBE, 2);
      totalhaber += this.toScalate(item.HABER, 2);
    }
    totaldebe = Number(totaldebe / Math.pow(10, 2))
    totalhaber = Number(totalhaber / Math.pow(10, 2))
    totalvar = this.toScalate(this.dblTotalFormaPagoarray[this.init.tabs[this.init.tabindex].indice], 2) + this.toScalate(totaldebe, 2) - this.toScalate(totalhaber, 2)
    totalvar = Number(totalvar / Math.pow(10, 2))
    this.cxcenccobmulti[this.init.tabs[this.init.tabindex].indice].TOTALVAR = Number(totalvar).toFixed(2);
  }
  async obtenerCaja(strTipoPago) {
    let strCaja = '';

    try {
      const rs = await this.erCajcodigoProm(strTipoPago);
      console.log(rs);
      strCaja = rs === null ? '' : (rs[0].CAJ_CODIGO === null ? '' : rs[0].CAJ_CODIGO);
    }
    catch (err) {
      this.message.add({
        key: 'cartera',
        severity: 'error',
        summary: 'Error',
        detail: 'No se puede obtener la caja ' + err.error
      });
    }
    return strCaja;
  }

  async obtenerCuentaCaja(strCaja) {
    let strCuenta = '';

    try {
      const rs = await this.erConcodigoProm(strCaja);
      console.log(rs);
      strCuenta = rs === null ? '' : (rs[0].CON_CODIGO === null ? '' : rs[0].CON_CODIGO);
    } catch (err) {
      this.message.add({
        key: 'cartera',
        severity: 'error',
        summary: 'Error',
        detail: 'No se puede consultar la cuenta contable de la caja ' + err.error
      });
    }
    return strCuenta;
  }

  async obtenerNombreBanco(strCodBanco) {
    let strNombre = '';

    try {
      const rs = this.erBanclinombreProm(strCodBanco);
      console.log(rs);
      strNombre = rs[0].BANCLI_NOMBRE === null ? '' : rs[0].BANCLI_NOMBRE;
    } catch (err) {
      this.message.add({
        key: 'cartera',
        severity: 'error',
        summary: 'Error',
        detail: 'No se puede consultar el nombre del banco ' + err.error
      });
    }
    return strNombre;
  }
  erCajcodigoProm(strFormapagotipo): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/carteraactiva/76d8a9b30d94300', {
      elementos: {
        FORMAPAGO_TIPO: strFormapagotipo
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }

  erConcodigoProm(strCajcodigo): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/carteraactiva/3b6cc5d986ca18', {
      elementos: {
        CAJ_CODIGO: strCajcodigo
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  erBanclinombreProm(strClicodigo): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/carteraactiva/3b6b55d9595f16', {
      elementos: {
        BANCLI_CODIGO: strClicodigo
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  eliminartrnvarios(item): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxccobmulti/1d595a5757778000000000000000', {
      elementos: {
        p_TRNCOBRO_NRODOC  :item.TRNCOBRO_NRODOC ,
        p_COM_CODIGO   :'01',
        p_TRNVARIOS_LINEA   :item.TRNVARIOS_LINEA 
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertaenccobmulti(item): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxccobmulti/257e3b7d53aec6000000000', {
      elementos: {
        p_enccob_codigo :item.ENCCOB_CODIGO,
        p_com_codigo :item.COM_CODIGO,
        p_enccob_comprobante  :item.ENCCOB_COMPROBANTE,
        p_enccob_fechaemision  :item.ENCCOB_FECHAEMISION,
        p_enccob_concepto  :item.ENCCOB_CONCEPTO,
        p_usuidentificacion  :this.usuario.identificacion,
        p_enccob_importe :item.ENCCOB_IMPORTE,
        p_ven_codigo :item.VEN_CODIGO,
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertadetcobmulti(item): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxccobmulti/257e3b7d535dd6000000000', {
      elementos: {
        p_enccob_codigo :item.ENCCOB_CODIGO,
        p_com_codigo :'01',
        p_detcob_nrodoc :item.DETCOB_NRODOC,
        p_detcob_importe :item.DETCOB_IMPORTE,
        p_detcob_nrocomprobante :'',
        p_detcob_ref :item.DETCOB_REF,
        p_cli_codigo :item.CLI_CODIGO,
        p_trncobro_nrodoc :'',
        p_contro_grabar    :item.CONTRO_GRABAR
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  eliminarbancaj(strcodigo): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxccobmulti/1d595a5756d6ac0000', {
      elementos: {
        p_enccob_codigo: strcodigo,
        p_com_codigo:'01'
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertacaja(item:Cxctrnformapago): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxccobmulti/4afc76faa62a68', {
      elementos: {
        p_CAJ_codigo_1   :item.CAJ_CODIGO,     
        p_TRNCAJ_fecha_2  :item.TRNPAGO_FECHA,     
        p_TRNCAJ_tipo_3   :item.TRNPAGO_TIPO,    
        p_TRNCAJ_numero_4  :item.TRNPAGO_NUMERO,      
        p_TRNCAJ_formapago_5  :item.TRNPAGO_TIPO,  
        p_TRNCAJ_docnro_6   :item.TRNCOBRO_NRODOC,  
        p_TRNCAJ_importe_7  :item.TRNPAGO_IMPORTE,  
        p_TRNCAJ_descripcion_8 :'PAGO MULTIPLE', 
        p_TRNCAJ_anulado :0,
        p_TRNCAJ_fechavenci_9  :'',    
        p_TRNCAJ_origen_10   :'CXC-MUL', 
        p_COM_codigo_11     :'01',  
        p_BANCLI_codigo_12   :'',
        p_USU_IDENTIFICACION :this.usuario.identificacion,
        p_CLI_codigo :'',
        p_cen_codigo :'',
        p_trnpago_nrocta  :item.TRNPAGO_NROCTA
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertabanco(item:Cxctrnformapago): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxccobmulti/95f8edf54b55d80', {
      elementos: {
        p_BAN_codigo_1    :item.BANCLI_CODIGO, 
        p_TRNBAN_fecha_2  :item.TRNPAGO_FECHA, 
        p_TRNBAN_tipo_3   :item.TRNPAGO_TIPO, 
        p_TRNBAN_numero_4   :item.TRNPAGO_NUMERO, 
        p_TRNBAN_docnro_5   :item.TRNCOBRO_NRODOC, 
        p_TRNBAN_importe_6  :item.TRNPAGO_IMPORTE, 
        p_TRNBAN_concepto_7   :item.TRNPAGO_CONCEPTO, 
        p_TRNBAN_beneficiario_9   :'', 
        p_TRNBAN_anulado_10   :0,
        p_CON_codigo_11     :item.CON_CODIGO, 
        p_COM_codigo_12     :'01', 
        p_TRNBAN_origen_13    :'CXC-MUL',
        p_TRNBAN_NUMEROREFUSER  :'',
        p_TRNBAN_FECHAVENCE  :item.TRNPAGO_FECHA,
        p_ENCREQ_NUMERO    :'',
        P_PRO_CODIGO :'',
        p_TRNBAN_PAGOELEC  :'',
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertarvarios(item:Cxctrnvarios): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxccobmulti/12bf1dbeabeadd000', {
      elementos: {
        p_TRNCOBRO_NRODOC  :item.TRNCOBRO_NRODOC,
        p_COM_CODIGO   :'01',
        p_TRNVARIOS_LINEA   :item.TRNVARIOS_LINEA,
        p_CON_CODIGO   :item.CON_CODIGO,
        p_TRNVARIOS_IMPORTE   :item.TRNVARIOS_IMPORTE,
        p_TRNCOBRO_NROCOMPROBANTE :item.TRNCOBRO_NROCOMPROBANTE,
        p_CON_NOMBRE :item.CON_NOMBRE,
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  generarasientocobmulti(codigo): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxccobmulti/20ebbb6adab92800000000000000', {
      elementos: {

        p_enccob_codigo :codigo,
        p_com_codigo :'01',
        p_origen :'CXC-MUL',
        p_tipdia_codigo :'CI',
        P_usuario: this.usuario.identificacion
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  generarcomprobantemulti(codigo): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxccobmulti/1075ddb56d98b6000000000000000000', {
      elementos: {

        p_enccob_codigo :codigo,
        p_com_codigo :'01',
        p_usuidentificacion :this.usuario.identificacion
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  reversastransacciones(codigo): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxccobmulti/dbbeedf15beef000000000000', {
      elementos: {
        p_enccob_codigo :codigo,
        p_com_codigo :'01',
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }

  getenccxccobmulti(codigo): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxccobmulti/20eebaec6617700000', {
      elementos: {
        p_enccob_codigo :codigo,
        p_com_codigo :'01',
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getdetcxccobmulti(codigo): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxccobmulti/20eeb5dd6617700000', {
      elementos: {
        p_enccob_codigo :codigo,
        p_com_codigo :'01',
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getformpagocobmulticaj(codigo): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxccobmulti/83bafc6ecacaa000000000000', {
      elementos: {
        p_enccob_codigo :codigo,
        p_com_codigo :'01',
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getformpagocobmultiban(codigo): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxccobmulti/41dd7e37656550000000000000000', {
      elementos: {
        p_enccob_codigo :codigo,
        p_com_codigo :'01',
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  gettrnvariospagomulti(codigo): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxccobmulti/83bbdddfeadcb000000000000', {
      elementos: {
        p_enccob_codigo :codigo,
        p_com_codigo :'01',
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  eliminarencocbmulti(codigo): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxccobmulti/3ab2b4aeadbaec0000000000', {
      elementos: {
        p_enccob_codigo :codigo,
        p_com_codigo :'01',
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getregistro(tipo,codigo): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxccobmulti/20eef1d573192c00000000000000', {
      elementos: {
        p_tipo :tipo,
        p_com_codigo :'01',
        p_enccob_codigo :codigo,
        
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  actualizaEstadoFactura(encfacnumero,clicod): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxccobmulti/299d773aa6e5ea000000000000000', {
      elementos: {
        p_com_codigo :'01',
        p_cli_codigo :clicod,
       
        p_encfac_numero :encfacnumero,
        
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
}
